const TZ = 'America/Sao_Paulo';

export const fmtDuration = (ms: number): string => {
  const s = Math.round((ms || 0) / 1000);
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  if (m < 60) return s % 60 && m < 10 ? `${m} min ${s % 60} s` : `${m} min`;
  const h = Math.floor(m / 60);
  return `${h} h ${String(m % 60).padStart(2, '0')} min`;
};

export const fmtDay = (d: string | Date): string =>
  new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, day: 'numeric', month: 'short' }).format(new Date(d)).replace('.', '');

export const fmtDate = (d: string | Date): string => new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, dateStyle: 'long' }).format(new Date(d));

export const fmtDateTime = (d: string | Date): string =>
  new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
    .format(new Date(d))
    .replace('.', '');

export const fmtTime = (d: string | Date): string => new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, hour: '2-digit', minute: '2-digit' }).format(new Date(d));

export const fmtRelative = (d: string | Date | null): string => {
  if (!d) return 'nunca';
  const s = Math.round((Date.now() - new Date(d).getTime()) / 1000);
  if (s < 45) return 'agora';
  if (s < 3600) return `há ${Math.round(s / 60)} min`;
  if (s < 86400) return `há ${Math.round(s / 3600)} h`;
  const days = Math.round(s / 86400);
  return days === 1 ? 'ontem' : days < 30 ? `há ${days} dias` : fmtDay(d);
};

// whole days left until the end of the validity day, in São Paulo
export const daysLeft = (expiresAt: string): number => Math.ceil((new Date(expiresAt).getTime() - Date.now()) / 86_400_000) - 1;

export const validityLabel = (expiresAt: string, expired: boolean): string => {
  if (expired) return `Venceu em ${fmtDay(expiresAt)}`;
  const n = daysLeft(expiresAt);
  return n <= 0 ? 'Vence hoje' : n === 1 ? `Válida até ${fmtDay(expiresAt)} · 1 dia` : `Válida até ${fmtDay(expiresAt)} · ${n} dias`;
};

export const todayIso = (offsetDays = 0): string => new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(new Date(Date.now() + offsetDays * 86_400_000));

export const PERIODS = { manha: 'Manhã, 9h às 12h', tarde: 'Tarde, 13h às 17h', noite: 'Fim de tarde, 17h às 19h' } as const;
export type Period = keyof typeof PERIODS;

export const fmtSlot = (s: { date: string; period: Period }): string =>
  `${new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short' }).format(new Date(`${s.date}T12:00:00Z`)).replace(/\./g, '')} · ${PERIODS[s.period]}`;

export const STATUS_LABEL = { draft: 'Rascunho', sent: 'Enviada', viewed: 'Visualizada', accepted: 'Aceita', expired: 'Expirada' } as const;
export type Status = keyof typeof STATUS_LABEL;

export const CAPTURE_LABEL: Record<string, string> = {
  printscreen: 'Tecla Print Screen',
  screenshot: 'Atalho de captura de tela',
  print: 'Imprimir ou salvar em PDF',
  copy: 'Texto copiado',
};
export const CONFIDENCE_LABEL: Record<string, string> = { alta: 'confiança alta', media: 'confiança média', info: 'informativo' };
